import { Form, Formik } from 'formik';
import React, { PropsWithChildren } from 'react';

import { InsuranceDetails } from 'Api/insurance';
import { FieldsWrapper } from '../cancelForm.styles';
import { submitEmailCancellationForm } from './emailCancellationForm.helpers';
import { getEmailCancellationFormValidation } from './emailCancellationForm.validation';
import { EmailCancellationFormValues } from './emailCancellationForm.values';

interface EmailCancellationFormProps extends PropsWithChildren {
  insuranceDetails: InsuranceDetails;
  setSubmitError: React.Dispatch<React.SetStateAction<boolean>>;
  setSubmitSuccess: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EmailCancellationForm = ({
  insuranceDetails,
  setSubmitError,
  setSubmitSuccess,
  children,
}: EmailCancellationFormProps) => {
  return (
    <Formik
      initialValues={{ manualMessage: '' }}
      validationSchema={getEmailCancellationFormValidation()}
      onSubmit={async (values: EmailCancellationFormValues) =>
        submitEmailCancellationForm(
          values,
          insuranceDetails,
          setSubmitError,
          setSubmitSuccess,
        )
      }
    >
      <Form>
        <FieldsWrapper>{children}</FieldsWrapper>
      </Form>
    </Formik>
  );
};
